// frontend/shared-ui/src/components/Button.jsx
import React from "react";
import Spinner from "./Spinner";

export default function Button({
  children,
  variant = "primary",
  size = "md",
  block = false,
  loading = false,
  disabled = false,
  icon = null,
  iconRight = null,
  type = "button",
  className = "",
  ...rest
}) {
  const classes = [
    "fh-btn",
    `fh-btn--${variant}`,
    size !== "md" ? `fh-btn--${size}` : "",
    block ? "fh-btn--block" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled || loading}
      {...rest}
    >
      {loading ? (
        <Spinner size="sm" />
      ) : (
        icon && <span className="fh-btn__icon">{icon}</span>
      )}
      {children && <span>{children}</span>}
      {iconRight && !loading && (
        <span className="fh-btn__icon">{iconRight}</span>
      )}
    </button>
  );
}
